import React from "react";
import { Chart, ArcElement } from "chart.js";
import './SadenDashboardItem.scss';

import { Doughnut } from "react-chartjs-2";
Chart.register(ArcElement);
const HalfCircleChart = ({ chartdata }) => {
  const data = {
    labels: chartdata?.labels,
    datasets: [
      {
        data: chartdata?.datasets?.data, // Adjust the values here as needed
        backgroundColor: chartdata?.datasets?.backgroundColor,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    // cutoutPercentage: 50, // Adjust the cutoutPercentage to control the size of the half-circle (50% for a half-circle)
    // rotation: -0.5 * Math.PI, // Rotate the chart by -0.5 * Math.PI (-90 degrees) to start from the top
    // circumference: Math.PI, // Set the circumference to Math.PI (180 degrees) for a half-circle
    // tooltips: {
    //   enabled: false, // Disable tooltips if needed
    // },
    // legend: {
    //   display: false, // Hide the legend if needed
    // },
  };

  return (
    <div className="chart-card">
      <div className="chart-cotntainer" style={{width:"65%",margin:"0 auto"}}>
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
};

export default HalfCircleChart;
